/** @jsx jsx */
import { jsx } from '@emotion/react';

import { VisuallyHidden } from '@coursera/cds-core';

import _t from 'i18n!nls/front-page';

/** Use during temporary experiments / Hero takeovers.
 * Adds screen reader-only h1 header to avoid SEO penalties. */
const SeoPageHeader = () => {
  return (
    <VisuallyHidden component="h1" className="rc-A11yScreenReaderOnly">
      {_t('Learn without limits')}
    </VisuallyHidden>
  );
};

export default SeoPageHeader;
